type Props = {
  width?: string;
  height?: string;
};

const EditVideoIcon = ({ width = '18', height = '18' }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.5"
      y="3"
      width="15"
      height="12"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M7 6.5L12 9L7 11.5V6.5Z" fill="currentColor" />
  </svg>
);

export default EditVideoIcon;
